import { render } from "./MenuCh.vue?vue&type=template&id=3e96ce34"
import script from "./MenuCh.vue?vue&type=script&lang=js"
export * from "./MenuCh.vue?vue&type=script&lang=js"

import "./MenuCh.vue?vue&type=style&index=0&id=3e96ce34&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__